export default __webpack_public_path__ + "static/media/avatar-nadja.cce0b385.png";